export class UserMediaDevicePlatformError extends Error {
    constructor({ mediaDevice, platform, originalError }, subType = 'unknown') {
        super(originalError.message);
        this.name = 'UserMediaDevicePlatformError';
        this.mediaDevice = mediaDevice;
        this.platform = platform;
        this.subType = subType;
        this.originalError = originalError;
    }
}
export function isUserMediaDevicePlatformError(error) {
    return error instanceof UserMediaDevicePlatformError;
}
